import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Link } from "wouter";
import data from "../../data/header";
import "./header.css";
import Styles from "./header.module.css";
import { Turn as Hamburger } from "hamburger-react";
import { motion } from "framer-motion";
import { ReactComponent as Divarrow } from "../../assets/header/Divarrow.svg";
import { ReactComponent as Headerlogo } from "../../assets/header/niurixlogo.svg";
import { ReactComponent as Navbarsvg } from "../../assets/header/navbar.svg";
import { ReactComponent as PlusIcon } from "../../assets/header/addicon.svg";
import { ReactComponent as Rightarrow } from "../../assets/homepage/RightArrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Parallax, Pagination } from "swiper/modules";
// import "../homepage/";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
const Header = (props) => {
    const [options, setOptions] = useState([]);
    const [page, setPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [url, setURL] = useState(null);
    const [scrolling, setScrolling] = useState(false);
    const headerClass = scrolling ? `${Styles.header_test}` : `${Styles.header_main}`;

    const [navbarOpen, setNavbarOpen] = useState(false);
    const [showNavbar, setShowNavbar] = useState(false);
    const [isActive, setIsActive] = useState(null);
    // const [isOpen, setisOpen] = useState(false);
    const [isOpen, setOpen] = useState(false);

    const [showOptions, setShowOptions] = useState("");

    const handleClickOptions = (option) => {
        setShowOptions(option);
    };
    // const VISIBLE_ITEMS = 4;
    const [currentIndex, setCurrentIndex] = useState(0);
    // const maxIndex = options.length - VISIBLE_ITEMS;
    // const isLeftDisabled = currentIndex === 0;
    // const isRightDisabled = currentIndex >= options.length - VISIBLE_ITEMS;

    // const swiperRef = useRef(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    // const handleClick = (item) => {
    //     setIsActive(isActive === item ? null : item);
    // };

    const handleLinkClick = () => {
        setNavbarOpen(false);
    };
    const toggleNavbar = () => {
        setOpen(!isOpen);
        // handleClickOptions("");
        setOptions([]);
    };

    const handleCloseClick = () => {
        setShowNavbar(false);
        setOpen(false);
    };

    const loadHeaderImage = (page, name) => {
        try {
            return require(`../../assets/header/${page}/${name}.webp`);
        } catch (error) {
            return require(`../../assets/header/solution/Configurations and Personalized Support.webp`);
        }
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 850) {
                setScrolling(true);
            } else {
                setScrolling(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        let currentUrl = window.location.href;
        let urlParts = currentUrl.split("/");
        let page = urlParts[3];
        setPage(page);
    }, [window.location.href]);

    useEffect(() => {
        if (page === null) {
            setIsBeginning(true);
            setIsEnd(false);
        }
    }, [page]);

    const handleItemClick = (item, option) => {
        if (page === item) {
            setOptions([]);
            setPage(null);
            setURL(null);
        } else {
            setPrevPage(page);
            setPage(item);
            setOptions(option);
            setURL(null);
            setIsBeginning(true);
            setIsEnd(false);
        }
    };

    return (
        <header className={Styles.header}>
            <div className={headerClass}>
                <div className={Styles.header_logo}>
                    <Link
                        href="/"
                        onClick={() => {
                            setOptions([]);
                            setPage(null);
                            setPrevPage(page);
                            setURL(null);
                            handleCloseClick();
                        }}
                    >
                        <Headerlogo onClick={handleCloseClick} />
                    </Link>
                </div>
                <nav className={Styles.header_container}>
                    <ul className={Styles.header_ul}>
                        <li
                            className={page === "solution" ? Styles.header_selected : Styles.header_items}
                            onClick={() => handleItemClick("solution", data.solutions)}
                        >
                            Solutions
                            <div
                                className={page === "solution" && options.length && !url ? Styles.solutions_arrow : Styles.dontdisplayarrow}
                            >
                                <Divarrow />
                            </div>
                        </li>
                        <li
                            className={page === "product" ? Styles.header_selected : Styles.header_items}
                            onClick={() => handleItemClick("product", data.products)}
                        >
                            Products
                            <div
                                className={page === "product" && options.length && !url ? Styles.solutions_arrow : Styles.dontdisplayarrow}
                            >
                                <Divarrow />
                            </div>
                        </li>

                        <li
                            className={page === "software" ? Styles.header_selected : Styles.header_items}
                            onClick={() => handleItemClick("software", [])}
                        >
                            <Link href="/gpon-software" className={page === "software" ? Styles.header_selected : Styles.header_items}>
                                Software
                            </Link>
                        </li>

                        <li
                            className={page === "industries" ? Styles.header_selected : Styles.header_items}
                            onClick={() => handleItemClick("industries", data.industries)}
                        >
                            Industries
                            <div
                                className={
                                    page === "industries" && options.length && !url ? Styles.solutions_arrow : Styles.dontdisplayarrow
                                }
                            >
                                <Divarrow />
                            </div>
                        </li>

                        <li className={Styles.contactus_button} onClick={() => handleItemClick("contact-us", [])}>
                            <Link href="/contact">
                                <a>Contact Us</a>
                            </Link>
                        </li>
                    </ul>
                </nav>

                {options.length && !url && page === "product" ? (
                    <div className={`${Styles.header_dropdown}`}>
                        <div
                            className={`${Styles.header_dropdown_content} ${Styles.header_dropdown_content_swiper}`}
                            // style={{
                            //     transform: `translateX(-${currentIndex * 25}%)`,
                            // }}
                        >
                            <span className={`${Styles.arrow} swiper-nav-prev`}>
                                <Rightarrow
                                    className={`${Styles.arrow_left} ${isBeginning ? Styles.arrow_disabled : Styles.arrow_active}`}
                                />
                            </span>
                            <Swiper
                                modules={[Navigation]}
                                slidesPerView={4}
                                slidesPerGroup={1}
                                allowTouchMove={false}
                                speed={600}
                                navigation={{
                                    prevEl: ".swiper-nav-prev",
                                    nextEl: ".swiper-nav-next",
                                }}
                                onSlideChange={(swiper) => {
                                    setIsBeginning(swiper.isBeginning);
                                    setIsEnd(swiper.isEnd);
                                }}
                                // parallax={true}
                                // pagination={{
                                //     clickable: true,
                                // }}
                                // modules={[Parallax, Pagination]}
                                className="mySwiper"
                            >
                                {options.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <Link
                                            key={index}
                                            href={item.url}
                                            onClick={() => {
                                                setURL(item.url);
                                                setPrevPage(page);
                                                setPage(item.page);
                                            }}
                                        >
                                            {page === "product" ? (
                                                <div className={`${Styles.header_products} ${Styles.header_products_swipper} `}>
                                                    <div className={`${Styles.header_products_img} ${Styles.header_products_img_swipper}`}>
                                                        <img src={loadHeaderImage(item.page, item.image)} alt="" />
                                                    </div>
                                                    <div className={Styles.header_span}>
                                                        <span className={Styles.type}>{item.type}</span>
                                                        <span className={Styles.model_no}>{item.modelNum}</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={Styles.header_dropdown_flex}>
                                                    <div className={Styles.header_dropdown_img}>
                                                        <img src={loadHeaderImage(item.page, item.image)} alt="" />
                                                    </div>
                                                    <div className={Styles.header_dropdown_heading}>
                                                        <p className={Styles.dropdown_link}>{item.name}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </Link>
                                    </SwiperSlide>
                                ))}{" "}
                            </Swiper>
                            <span className={`${Styles.arrow} swiper-nav-next`}>
                                <Rightarrow className={`${Styles.arrow_right} ${isEnd ? Styles.arrow_disabled : Styles.arrow_active}`} />
                            </span>
                        </div>
                    </div>
                ) : null}

                {options.length && !url && page !== "product" ? (
                    <div className={`${Styles.header_dropdown} ${Styles.carousel_wrapper}`}>
                        {/* {page === "products" ? (
                            <span className={`${Styles.arrow} ${isLeftDisabled ? Styles.disabled : ""}`} onClick={handlePrev}>
                                ◀
                            </span>
                        ) : null} */}
                        <div className={Styles.carousel_window}>
                            <div
                                className={Styles.header_dropdown_content}
                                style={{
                                    transform: `translateX(-${currentIndex * 25}%)`,
                                }}
                            >
                                {options.map((item, index) => (
                                    <Link
                                        key={index}
                                        href={item.url}
                                        onClick={() => {
                                            setURL(item.url);
                                            setPrevPage(page);
                                            setPage(item.page);
                                        }}
                                    >
                                        {page === "product" ? (
                                            <div className={Styles.header_products}>
                                                <div className={Styles.header_products_img}>
                                                    <img src={loadHeaderImage(item.page, item.image)} alt="" />
                                                </div>
                                                <div className={Styles.header_span}>
                                                    <span className={Styles.type}>{item.type}</span>
                                                    <span className={Styles.model_no}>{item.modelNum}</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={Styles.header_dropdown_flex}>
                                                <div className={Styles.header_dropdown_img}>
                                                    <img src={loadHeaderImage(item.page, item.image)} alt="" />
                                                </div>
                                                <div className={Styles.header_dropdown_heading}>
                                                    <p className={Styles.dropdown_link}>{item.name}</p>
                                                </div>
                                            </div>
                                        )}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* {page === "products" ? (
                            <span className={`${Styles.arrow} ${isRightDisabled ? Styles.disabled : ""}`} onClick={handleNext}>
                                ▶
                            </span>
                        ) : null} */}
                    </div>
                ) : null}
            </div>

            <div className={isOpen ? Styles.header_mob : Styles.header_initial}>
                <div className={isOpen ? Styles.header_box_shadow_container : Styles.header_wrapper}>
                    <Link to="/">
                        <div className={Styles.header_logo_wrapper}>
                            <Headerlogo />
                        </div>
                    </Link>

                    <div
                        className={Styles.hamburger_logo}
                        //  onClick={toggleNavbar}
                    >
                        <Hamburger
                            size={25}
                            duration={0.5}
                            color="#FF5B02"
                            easing="ease-in"
                            // toggled={this.state.showNavbar}
                            // onToggle={toggleNavbar}
                            // onToggle={(toggled) => {
                            //     setShowNavbar(toggled);
                            //     handleClickOptions();
                            // }}
                            toggled={isOpen}
                            toggle={setOpen}
                        />
                    </div>
                </div>
                {isOpen ? (
                    <div className={Styles.tab_n_mobile_header}>
                        <div className={`${Styles.hamburger_contents_wrapper}`}>
                            <div className={Styles.header_card_wrapper}>
                                <nav className={Styles.header_cards}>
                                    <ul>
                                        <li>
                                            {" "}
                                            <div
                                                onClick={() => {
                                                    showOptions !== "Solution" ? handleClickOptions("Solution") : handleClickOptions("");
                                                }}
                                                className={Styles.header_card}
                                            >
                                                <div className={Styles.header_card_heading}>Solutions</div>
                                                <div className={Styles.plus_logo}>
                                                    <PlusIcon className={showOptions === "Solution" ? Styles.close : Styles.plus} />
                                                </div>
                                            </div>
                                            {showOptions === "Solution" && (
                                                <motion.div
                                                    style={{ overflow: "hidden" }}
                                                    initial={{
                                                        opacity: 1,
                                                        height: "0",
                                                    }}
                                                    animate={{
                                                        opacity: 1,
                                                        height: "12rem",
                                                    }}
                                                    transition={{
                                                        duration: 0.8,
                                                    }}
                                                    className={Styles.header_card_dropdown}
                                                >
                                                    <Link
                                                        href="/solution/optimized-fiber-optic-solution"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Optimized Fiber-Optic Solution
                                                        </p>
                                                    </Link>
                                                    <Link
                                                        href="/solution/fibers-edge-over-copper"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Fiber's Edge Over Copper
                                                        </p>
                                                    </Link>
                                                    <Link
                                                        href="/solution/scalable-and-future-ready-design"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Scalable and Future -Ready Design
                                                        </p>
                                                    </Link>
                                                    <Link
                                                        href="/solution/configurations-and-personalized-support"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Configurations and Personalized Support
                                                        </p>
                                                    </Link>
                                                </motion.div>
                                            )}
                                        </li>
                                        <li>
                                            <div
                                                onClick={() => {
                                                    showOptions !== "Product" ? handleClickOptions("Product") : handleClickOptions("");
                                                }}
                                                className={Styles.header_card}
                                            >
                                                <div className={Styles.header_card_heading}>Products</div>
                                                <div className={Styles.plus_logo}>
                                                    <PlusIcon className={showOptions === "Product" ? Styles.close : Styles.plus} />{" "}
                                                </div>
                                            </div>
                                            {showOptions === "Product" && (
                                                <motion.div
                                                    style={{ overflow: "hidden" }}
                                                    initial={{
                                                        opacity: 1,
                                                        height: "0",
                                                    }}
                                                    animate={{
                                                        opacity: 1,
                                                        height: "14rem",
                                                    }}
                                                    transition={{
                                                        duration: 0.8,
                                                    }}
                                                    className={`${Styles.header_card_dropdown} ${Styles.header_products_scroll}`}
                                                >
                                                    <Link
                                                        href="/product/ONT-P4200R"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            P4200R
                                                        </p>
                                                    </Link>
                                                    {/* <Link
                                                        href="/product/ONT-G2410"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            G2410{" "}
                                                        </p>
                                                    </Link> */}
                                                    <Link
                                                        href="/product/ONT-T2001"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            T2001{" "}
                                                        </p>
                                                    </Link>
                                                    <Link
                                                        href="/product/OLT-SOLT33-8P"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            SOLT33- 8P{" "}
                                                        </p>
                                                    </Link>
                                                    {/* <Link
                                                        href="/product/OLT-SOLT33-16P"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            SOLT33- 16P{" "}
                                                        </p>
                                                    </Link> */}
                                                    <Link
                                                        href="/product/OLT-XGSPON-8P"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            MOLT-XGSPON 8P{" "}
                                                        </p>
                                                    </Link>{" "}
                                                    {/* <Link
                                                        href="/product/OLT-XGSPON-16P"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            MOLT - XGSPON 16P{" "}
                                                        </p>
                                                    </Link> */}
                                                </motion.div>
                                            )}
                                        </li>
                                        <li>
                                            <div className={Styles.header_card}>
                                                <Link
                                                    href="/gpon-software"
                                                    style={{ cursor: "pointer", textDecoration: "none" }}
                                                    onClick={handleLinkClick}
                                                >
                                                    {" "}
                                                    <p className={Styles.header_card_heading} onClick={handleCloseClick}>
                                                        Software{" "}
                                                    </p>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            {" "}
                                            <div
                                                onClick={() => {
                                                    showOptions !== "Industries"
                                                        ? handleClickOptions("Industries")
                                                        : handleClickOptions("");
                                                }}
                                                className={Styles.header_card}
                                            >
                                                <div className={Styles.header_card_heading}>Industries</div>
                                                <div className={Styles.plus_logo}>
                                                    <PlusIcon className={showOptions === "Industries" ? Styles.close : Styles.plus} />{" "}
                                                </div>
                                            </div>
                                            {showOptions === "Industries" && (
                                                <motion.div
                                                    style={{ overflow: "hidden" }}
                                                    initial={{
                                                        opacity: 1,
                                                        height: "0",
                                                    }}
                                                    animate={{
                                                        opacity: 1,
                                                        height: "10rem",
                                                    }}
                                                    transition={{
                                                        duration: 0.8,
                                                    }}
                                                    className={Styles.header_card_dropdown}
                                                >
                                                    <Link
                                                        href="/industries/hospitality-solutions"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Hospitality
                                                        </p>
                                                    </Link>
                                                    <Link
                                                        href="/industries/corporate-workspaces-solutions"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Corporate Workspaces
                                                        </p>
                                                    </Link>
                                                    {/* <Link
                                                        href="/industries/residential-real-estate-solutions"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Residential Real estate{" "}
                                                        </p>
                                                    </Link> */}
                                                    <Link
                                                        href="/industries/student-living-solutions"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {" "}
                                                        <p className={Styles.header_card_content} onClick={handleCloseClick}>
                                                            Student Living{" "}
                                                        </p>
                                                    </Link>
                                                </motion.div>
                                            )}
                                        </li>
                                        <li>
                                            {/* <div className={Styles.header_card}>
                                                <Link to="" style={{ cursor: "pointer", textDecoration: "none" }} onClick={handleLinkClick}>
                                                    {" "}
                                                    <p className={Styles.header_card_heading} onClick={handleCloseClick}>
                                                        Blogs
                                                    </p>
                                                </Link>
                                            </div> */}
                                        </li>
                                    </ul>
                                </nav>
                                <div className={Styles.menu_header_btn}>
                                    <Link href="/contact">
                                        <div className={Styles.hamburger_contact_btn}>
                                            <button onClick={handleCloseClick} className={Styles.header_contact_btn}>
                                                Contact Us
                                            </button>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </header>
    );
};
export default Header;
